module.exports = __webpack_public_path__ + "static/media/ODS09.906263f1.jpg";